import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { CustomerParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { DateRange } from '@project-types/DateRange';



export const selectGridData = (state: RootState) => state.reportingDeliveriesCustomer.gridData;
export const selectDateRange = (state: RootState) => state.reportingDeliveriesCustomer.dateRange;



export const selectValidParams = createSelector(
	[
		selectDateRange,
	],(
		dateRange: DateRange | null,
	) => {
		if (!dateRange) return null;
		let validParams: CustomerParams = {
			dateFrom: dateRange.from,
			dateTo: dateRange.to,
		};
		return validParams;
	}
);